<template>
  <v-main>
    <v-container fluid>
     <v-row>
        <v-col>
          <h1 class="mt-n5 mb-n5">{{ $t('Translations') }}</h1>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="6">
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            :label="$t('Search')"
            solo
            hide-details
          ></v-text-field>
        </v-col>
        <v-col cols="6">
          <LanguagePicker v-model="lang" :disabled="preventLeave"></LanguagePicker>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-btn :disabled="saving" min-width="97px" :loading="saving" @click="submit" class="ml-1 mt-n1 mr-2" color="primary">{{ $t('Save') + buttonAppend }}</v-btn>
          <v-btn :disabled="buttonAppend == ''" @click="cancel" class="mr-2 mt-n1" color="error">{{ $t('Cancel') }}</v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-data-table
            hide-default-footer
            :headers="headers"
            :items="items"
            :items-per-page="Infinity"
            :search="search"
            class="elevation-1"
            :mobile-breakpoint="900"
          >
            <template v-slot:[`item.custom`]="{ item }">
              <v-text-field class="ma-2" style="min-width: 400px;" hide-details solo v-model="item.custom"></v-text-field>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
import LanguagePicker from '@/core/components/LanguagePicker'
import * as Lang from '@/core/lang'
import { loadTranslations, saveTranslations } from '@/core/translations'
import preventLeave from '@/core/mixins/preventLeave'

export default {
  mixins: [preventLeave],
  components: {
    LanguagePicker
  },
  data () {
    return {
      lang: 'en',
      search: '',
      translations: [],
      messages: {},
      saving: false,
      items: []
    }
  },
  watch: {
    lang: {
      async handler (val) {
        // Load the corresponding language file when changing language
        if (val === 'en') this.messages = this.$i18n.messages[val]
        else this.messages = await Lang.loadTranslation(val)
        // Also reload custom translations
        this.translations = await loadTranslations()
        // Update the items
        this.updateItems()
      },
      immediate: true
    },
    items: {
      handler (val) {
        this.preventLeave = true
      },
      immediate: false,
      deep: true
    }
  },
  methods: {
    async cancel () {
      // Load the corresponding language file when changing language
      if (this.lang === 'en') this.messages = this.$i18n.messages[this.lang]
      else this.messages = await Lang.loadTranslation(this.lang)
      // Also reload custom translations
      this.translations = await loadTranslations()
      // Update the items
      this.updateItems()
      this.saving = false
      this.preventLeave = false
    },
    async submit () {
      this.saving = true
      // Get a custom translations object, by keeping all the table rows which has custom text defined
      const customTranslations = this.items.filter(t => {
        return t.custom !== undefined && t.custom !== ''
      })

      const saveArray = []
      customTranslations.map(t => {
        saveArray.push({
          LangCode: this.lang,
          KeyText: t.key,
          CustomText: t.custom
        })
      })

      // Get the translations for other languages
      const otherTranslations = this.translations.filter(t => {
        return t.LangCode !== this.lang
      })

      await saveTranslations(saveArray.concat(otherTranslations))
      this.saving = false
      this.preventLeave = false
    },
    updateItems () {
      // Get the items for the table, by merging the custom translations with the translation messages defined by language file
      const entries = Object.entries(this.messages)
      // Only get keys from currently selected language
      const translations = this.translations.filter(t => {
        return t.LangCode === this.lang
      })
      // Transform the array to an object of translation keys and values (for faster retrieval)
      const translationObj = {}
      translations.map(t => {
        translationObj[t.KeyText] = t.CustomText
      })
      // Loop through all the language keys and retrieve the custom translations where applicable
      this.items = entries.map(entry => {
        const key = entry[0]
        return {
          key,
          original: entry[1],
          custom: translationObj[key]
        }
      })

      this.$nextTick(() => {
        this.preventLeave = false
      })
    }
  },
  computed: {
    headers () {
      return [
        { text: this.$t('Key'), value: 'key' },
        { text: this.$t('Original value'), value: 'original' },
        { text: this.$t('Custom value'), value: 'custom' }
      ]
    }
  }
}
</script>

<style>
</style>
